var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBlogsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3039",
    "data-name": "Rectangle 3039",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_blogs",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blog_-_Free_seo_and_web_icons-2",
    "data-name": "Blog - Free seo and web icons-2",
    transform: "translate(1.957 2.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14517",
    "data-name": "Path 14517",
    d: "M16.65,18.568l-2.68.951a.5.5,0,0,1-.64-.64l.951-2.68a.1.1,0,0,1,.025-.039L21.4,9.068a.9.9,0,0,1,1.267,0l1.117,1.117a.9.9,0,0,1,0,1.267l-7.091,7.09A.1.1,0,0,1,16.65,18.568Zm2.723-.475v2.49A2.37,2.37,0,0,1,17,22.952H4.369A2.37,2.37,0,0,1,2,20.583V9.528H18.7l-5.515,5.515a1.682,1.682,0,0,0-.4.629l-.951,2.679A2.081,2.081,0,0,0,14.5,21.007l2.679-.951C17.414,19.973,19.373,18.093,19.373,18.093ZM5.948,19h2.5a.79.79,0,1,0,0-1.579h-2.5a.79.79,0,1,0,0,1.579Zm0-3.159H10.03a.79.79,0,0,0,0-1.579H5.948a.79.79,0,0,0,0,1.579Zm0-3.159h7.24a.79.79,0,1,0,0-1.579H5.948a.79.79,0,0,0,0,1.579ZM2,7.948V6.369A2.37,2.37,0,0,1,4.369,4H17a2.37,2.37,0,0,1,2.369,2.369V7.948Z",
    transform: "translate(-2 -4)",
    fill: "#003fb9",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlogsNew);
export default __webpack_public_path__ + "static/media/ic_blogs_new.9ec194d0c69ac5047eabd580182f2dd4.svg";
export { ForwardRef as ReactComponent };